import React, { useEffect, useMemo } from "react";
import ReactSelect, { components } from "react-select";
import MyErrorBoundary from "../../utils/ErrorBoundary";
const Option = (props) => {
  return (
    <MyErrorBoundary>
      
    <div>
      <components.Option {...props}>
        <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input asCompatible"
            name="vlanOptions"
            id="vlanOptions1"
            value={props.isSelected}
            checked={props.isSelected}
            onChange={() => props.selectOption(props.data)}
          />
          <label
            className="custom-control-label line-height-25"
            htmlFor="vlanOptions1"
          >
            {props.label}
          </label>
        </div>
      </components.Option>
    </div>
    </MyErrorBoundary>
  );
};
const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
};
const groupBadgeStyles = {
  backgroundColor: "#EBECF0",
  borderRadius: "2em",
  color: "#172B4D",
  display: "inline-block",
  fontSize: 12,
  fontWeight: "normal",
  lineHeight: "1",
  minWidth: 1,
  padding: "0.16666666666667em 0.5em",
  textAlign: "center"
};
// Code : Function not used
// const formatGroupLabel = data => (
//   <div style={groupStyles}>
//     <span>{data.label}</span>
//     <span style={groupBadgeStyles}>{data.options.length}</span>
//   </div>
// );

const MultiSelectionDropdown = ({
  secureData,
  trunkMembers,
  getTrunkMembers,
  selectedMemberType,
  vlanConfigurationType,
  isDisabled,
  hasConflict,
  conflictVlans,
}) => {

  // Option component defined inside to access conflictVlans
  const ConflictAwareOption = (optionProps) => {
    const isConflict = Array.isArray(conflictVlans) && conflictVlans.includes(optionProps.data?.vlan);
    return (
      <MyErrorBoundary>
        <div>
          <components.Option {...optionProps}>
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input asCompatible"
                name="vlanOptions"
                id={`vlanOptions-${optionProps.data?.vlan || optionProps.label}`}
                value={optionProps.isSelected}
                checked={optionProps.isSelected}
                onChange={() => optionProps.selectOption(optionProps.data)}
              />
              <label
                className="custom-control-label line-height-25"
                htmlFor={`vlanOptions-${optionProps.data?.vlan || optionProps.label}`}
                style={isConflict ? { color: "#dc3545", fontWeight: "bold" } : {}}
              >
                {optionProps.label}{isConflict ? " ⚠" : ""}
              </label>
            </div>
          </components.Option>
        </div>
      </MyErrorBoundary>
    );
  };

  
  const dropDownStyles = {
    container:(provided)=>({
      ...provided,
      maxWidth:"100px",
  }),
 control:(provided, state) =>({
    ...provided,
    minHeight: "28px",
    width: "240px",
    borderColor: hasConflict ? "#dc3545" : (state.hasValue ? provided.borderColor : "#dc3545"),
    "&:hover": {
      borderColor: hasConflict ? "#dc3545" : (state.hasValue ? provided.borderColor : "#dc3545")
    }
  }),
    valueContainer: (provided, state) => ({
      ...provided,
      textOverflow: "ellipsis",
      maxWidth: "90%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      display: "flex",
      flexWrap:"nowrap",
       }),
    placeholder: (provided) =>({
      ...provided,
      display:"inline-block",
    }),
    option: (provided, state) => {
      const isConflict = Array.isArray(conflictVlans) && conflictVlans.includes(state.data?.vlan);
      return {
        ...provided,
        backgroundColor: isConflict ? "#fff3f3" : "transparent",
        color: isConflict ? "#dc3545" : "black",
        display: "flex",
        alignItems: "start",
        flexGap: "5px",
        fontFamily: "Nunito, sans-serif",
        fontStyle: "normal",
        fontSize: "0.875rem",
      };
    },
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color:"#495057",
      "& svg": {
        width: "16px",
        height: "16px"
      },
      padding:"2px",
    }),
    clearIndicator: (provided, state) => ({
      ...provided,
      color: '#495057',
      "& svg": {
        width: "16px",
        height: "16px"
      },
      padding:"2px",
    })
    
  };

  
  const handleChange = (selected) => {
    getTrunkMembers(selected, selectedMemberType);
  };

  const optionsNetworks = () => {
    const architecture = Array.isArray(secureData?.securedCommunicationArchitecture)
      ? secureData.securedCommunicationArchitecture
      : [];

    const networks = architecture
      .filter((network) => network && typeof network === "object")
      .map(
      (network) => ({
        ...network,
        label: network.vlan,
        value: network.vlan,
      })
      );
    if(vlanConfigurationType === "fortigate"){
       return networks;
      // return networks.filter(item=> ["Control", "Breakers", "Meters", "Relays", "EMA_WAN"].includes(item.vlan))
    }else{
        return networks;
    }
  
  };
  const selectedNetworks = useMemo(() => {
    const obj1 = optionsNetworks();
    const obj2 = Array.isArray(trunkMembers?.hybridMembers)
      ? trunkMembers.hybridMembers.filter((item) => item && typeof item === "object")
      : [];
    if (obj2.length === 0) {
      return [];
    } else {
      const members = obj1?.filter((obj1Item) =>
        obj1Item && obj2.some((obj2Item) => obj2Item && obj1Item.pvid === obj2Item.pvid)
      );
      return members?.map(member => ({
        label: member.vlan,
        value: member.vlan,
        ...member
      }));
    }
  }, [optionsNetworks, trunkMembers]);
  
  const multiValueContainer = ({ selectProps, data }) => {
    const label = data.label;
    const allSelected = selectProps.value;
    const index = allSelected.findIndex(selected => selected.label === label);
    const isLastSelected = index === allSelected.length - 1;
    const labelSuffix = isLastSelected ? ` --(${allSelected.length})` : ", ";
    const val = `${label}${labelSuffix}`;
    const isConflict = Array.isArray(conflictVlans) && conflictVlans.includes(data?.vlan);
   return <div style={{display:"inline-flex", fontSize:"14px", fontFamily:"Nunito, sans-serif", color: isConflict ? "#dc3545" : "#495057", fontWeight: isConflict ? "bold" : "normal"}}>{val}</div>;
  };
  
  return (
    <>
      <ReactSelect
        menuMaxHeight={200}
        menuPortalTarget={document.body}
        options={optionsNetworks()}
        value={selectedNetworks}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option: ConflictAwareOption,
          MultiValueContainer: multiValueContainer
        }}
        onChange={handleChange}
        allowSelectAll={true}
        hideClearIcon={true}
        styles={dropDownStyles}
        menuPlacement="auto"
        isDisabled={isDisabled}
      />
    </>
  );
};

export default MultiSelectionDropdown;